import React from "react";
import Cookies from "universal-cookie";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";

import Logeo from "./Logeo";
import Menu from "./Menu";

import Navegador from "./Navegador";

//Usuarios
import IndexUsuario from "./GestionUsuario/IndexUsuario";
import FomularioIndex from "./GestionUsuario/FormularioUsuario";

//Gestión Institucional
import Objetivos from "./GestionInstitucional/Objetivos";
import Cosevi from "./GestionInstitucional/Cosevi";
import Responsable from "./GestionInstitucional/Responsable";
import ActaConformacionCOSEVI from "./GestionInstitucional/ActaConformacionCOSEVI";
import PoliticaSeguridadVial from "./GestionInstitucional/PoliticaSeguridadVial";
import Divulgacion from "./GestionInstitucional/Divulgacion";
import CaracteristicasEmpresa from "./GestionInstitucional/CaracteristicasEmpresa";

import IndexArchivos from "./Formato/IndexArchivos";
import FormatoArchivos from "./Formato/FormatoArchivos";

import RegistrosViales from "./GestionInstitucional/RegistrosViales";

//Atencion a victimas
import Registros from "./AtencionVictimas/Registros";
import TarjetaReporte from "./AtencionVictimas/TarjetaReporte";
import Caracterizacion from "./AtencionVictimas/Caracterizacion";

/* ---- Gestion Mantenimietno ---- */
import HojaVida from "./VehiculoSeguro/HojaVidaVehiculos";
import GestionMantenimientoCoductores from "./GestionMantenimiento/GestionMantenimientoConductores";
import GestionMantetenimientoMontaCarga from "./GestionMantenimiento/GestionMantenimientoMontacarga";
import RegistrarUsuario from "./Registrar/RegistrarUsuario";
import ListaPreoperativaVehiculos from "./GestionMantenimiento/ListaPreoperativaVehiculos";
import RegistrarNumero from "./Registrar/RegistrarNumero";
import ConsultarNumero from "./Registrar/ConsultarNumeros";

import Datos_Configuracion from "./GestionDatos/Datos_Configuracion";
import CECDR from "./GestionInstitucional/CECDR";
import Calendar from "./GestionTareas/Calendar";
import IndicadorESV from "./VehiculosSeguros/IndicadorESV";
import EncuestaEsv from "./AdministracionUsuarios/EncuestaEsv";
import PreguntasEsv from "./AdministracionUsuarios/PreguntasEsv";
import AdministrarEncuestado from "./AdministracionUsuarios/AdministrarEncuestados";

/* ---- Gestion Mantenimietno ---- */
import MantenimientoVehiculos from "./MantenimientoVehiculos/Inicio";
import ConsultarKilometraje from "./MantenimientoVehiculos/Kilometraje/Consultar";
import RegistrarKilometraje from "./MantenimientoVehiculos/Kilometraje/Registrar";
import ConsultarMantenimiento from "./MantenimientoVehiculos/Matenimiento/Consultar";
import RegistrarMantenimiento from "./MantenimientoVehiculos/Matenimiento/Registar";
import FichaMantenimiento from "./MantenimientoVehiculos/Matenimiento/Ficha";
import IndicadorFlota from "./MantenimientoVehiculos/IndicadorFlota";
import ConsultarRutina from "./MantenimientoVehiculos/Rutinas/Consultar";
import InformeKilometraje from "./MantenimientoVehiculos/InformeKilometraje";
import RegistrarRutina from "./MantenimientoVehiculos/Rutinas/Registrar";

/* ----- Gestion de Indicadores -------- */

import Indicadores from "./Indicadores/Inicador";
import FormularioIndicadores from "./Indicadores/FormularioIndicadores";
import { ROUTES } from "./core/routes/routes";
import RegisterAccidents from "./module/reportRoadAccidents/RegisterAccidents";
import RegisterInvestigation from "./module/investigationRoadAccidents/RegisterInvestigation";
import RegisterClaimsAndLegalCosts from "./module/claimAndLegalCosts/RegisterClaimsAndLegalCosts";
import RegisterDisseminationLesson from "./module/disseminationLesson/RegisterDisseminationLesson";
import RegisterRiskMatrix from "./module/riskMatrix/RegisterRiskMatrix";
import IdentifiedRisks from "./module/riskMatrix/IdentifiedRisks";
import WorkPlanAndTraining from "./module/workPlanAndTraining/WorkPlanAndTrainingKanban";
import ComplianceAnnualPlanActivities from "./module/workPlanAndTraining/ComplianceAnnualPlanActivities";
import GoalsAndCompliance from "./module/workPlanAndTraining/GoalsAndCompliance";
import VariousDocumentAdmin from "./module/VariousDocumentAdmin/VariousDocumentAdmin";
import SpeedManagment from "./module/speedManagment/SpeedManagment";
import Preoperative from "./module/preoperative/Preoperative";
import SubMaintenance from "./module/subMaintenance/SubMaintenance";
import MonthlyReport from "./module/evidence/MonthlyReport";
import NumberOfTrips from "./module/evidence/NumberOfTrips.jsx";
import Infractions from "./module/infractions/Infractions.jsx";
import CallToAttention from "./module/callToAttention/CallToAttention.jsx";
import ExcelVehicleInspection from "./module/vehicleInspection/ExcelVehicleInspection.jsx";
import CopyFormatsUsed from "./module/evidence/CopyFormatsUsed.jsx";
import RelationPreventiveMaintenance from "./module/maintenance/RelationPreventiveMaintenance.jsx";
import CountFaults from "./module/evidence/CountFaults.jsx";
import ListAccidents from "./module/reportRoadAccidents/ListAccidents.jsx";
import ListInvestigations from "./module/investigationRoadAccidents/ListInvestigation.jsx";
import ListDisseminationLesson from "./module/disseminationLesson/ListDisseminationLesson.jsx";
import Indicators from "./module/indicators/Indicators.jsx";
import RegisterLegalProcessDocuments from "./module/legalProcessDocument/RegisterDocuments.jsx";
import ListLegalProcessDocuments from "./module/legalProcessDocument/ListDocuments.jsx";
import ListLegalProvisionDocuments from "./module/legalProvisionDocument/ListDocuments.jsx";
import RegisterLegalProvisionDocuments from "./module/legalProvisionDocument/RegisterDocuments.jsx";
import ListAuditLogs from "./module/auditLog/ListAuditLogs.jsx";
import ListSpeedManagment from "./module/speedManagment/ListSpeedManagment.jsx";
import ListInfractions from "./module/infractions/ListInfractions.jsx";
import ListCallToAttention from "./module/callToAttention/ListCallToAttention.jsx";
import ListMaintenance from "./module/maintenance/ListMaintenance.jsx";
import RegisterMaintenance from "./module/maintenance/RegisterMaintenance.jsx";
import ListFunctionalityIndicators from "./module/functionalityIndicators/ListFunctionalityIndicators.jsx";
import RegisterFunctionalityIndicators from "./module/functionalityIndicators/RegisterFunctionalityIndicators.jsx";
import RegisterDailyIndicators from "./module/functionalityIndicators/RegisterDailyIndicators.jsx";
import RegisterMonthlyIndicators from "./module/functionalityIndicators/RegisterMonthlyIndicators.jsx";
import ListMonthlyReportPdf from "./module/functionalityEvidence/ListMonthlyReportPdf.jsx";
import RegisterMonthlyReportPdf from "./module/functionalityEvidence/RegisterMonthlyReportPdf.jsx";
import ListSpeedLimitCertificate from "./module/functionalityEvidence/ListSpeedLimitCertificate.jsx";
import RegisterSpeedLimitCertificate from "./module/functionalityEvidence/RegisterSpeedLimitCertificate.jsx";
import ListStaffTimeControl from "./module/functionalityEvidence/ListStaffTimeControl.jsx";
import RegisterStaffTimeControl from "./module/functionalityEvidence/RegisterStaffTimeControl.jsx";
import ListWorkRoutesList from "./module/functionalityEvidence/ListWorkRoutesList.jsx";
import RegisterWorkRoutesLst from "./module/functionalityEvidence/RegisterWorkRoutesList.jsx";
import Dashboard from "./module/dashboard/Dashboard.jsx";
import VehicleInspection from "./module/vehicleInspection/VehicleInspection.jsx";

const RequiredAuth = ({ children, redirectTo }) => {
  let authorized = false;
  const cookie = new Cookies();
  const access_token = cookie.get("perv_v2_cookies_user_kdfoeinapjdkfawep");
  if (access_token === null || access_token === undefined) {
    authorized = false;
  } else {
    authorized = true;
  }
  return authorized ? children : <Navigate to={redirectTo} />;
};
function Rutas() {
  return (
    <Routes className="mt-5">
      <Route index element={<Logeo />} />
      <Route path="/" element={<Layout />}>
        <Route
          exact
          path="/Menu"
          element={
            <RequiredAuth redirectTo="/">
              <Menu />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.DASHBOARD}
          element={
            <RequiredAuth redirectTo="/">
              <Dashboard />
            </RequiredAuth>
          }
        />

        <Route exact path="/GestionUsuario" element={<IndexUsuario />} />
        <Route
          exact
          path="/FomularioUsuario/:datos"
          element={
            <RequiredAuth redirectTo="/">
              <FomularioIndex />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/GestionInstitucionalPoliticaSeguridadVial"
          element={
            <RequiredAuth redirectTo="/">
              <PoliticaSeguridadVial />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/GestionInstitucionalObjetivos"
          element={
            <RequiredAuth redirectTo="/">
              <Objetivos />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/GestionInstitucionalCosevi"
          element={
            <RequiredAuth redirectTo="/">
              <Cosevi />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/ResponsablePESV"
          element={
            <RequiredAuth redirectTo="/">
              <Responsable />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/ActaConformacionCOSEVI"
          element={
            <RequiredAuth redirectTo="/">
              <ActaConformacionCOSEVI />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/Divulgacion"
          element={
            <RequiredAuth redirectTo="/">
              <Divulgacion />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/CaracteristicasEmpresa"
          element={
            <RequiredAuth redirectTo="/">
              <CaracteristicasEmpresa />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/IndexArchivos"
          element={
            <RequiredAuth redirectTo="/">
              <IndexArchivos />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/FormatoArchivos/:dato"
          element={
            <RequiredAuth redirectTo="/">
              <FormatoArchivos />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/GestionInstitucionalRegistrosViales"
          element={
            <RequiredAuth redirectTo="/">
              <RegistrosViales />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/RegistrosCaracteristicas"
          element={
            <RequiredAuth redirectTo="/">
              <Registros />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/AtecionVictimasTarjetaReporte"
          element={
            <RequiredAuth redirectTo="/">
              <TarjetaReporte />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/AtecionVictimasCaracterizacion/:datos"
          element={
            <RequiredAuth redirectTo="/">
              <Caracterizacion />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/VehiculoSeguroHojaVidaVehiculos"
          element={
            <RequiredAuth redirectTo="/">
              <HojaVida />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/lista-preguntas-preoperacional"
          element={
            <RequiredAuth redirectTo="/">
              <ListaPreoperativaVehiculos />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/conductores"
          element={
            <RequiredAuth redirectTo="/">
              <GestionMantenimientoCoductores />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/gestion-mantenimiento/montacarga"
          element={
            <RequiredAuth redirectTo="/">
              <GestionMantetenimientoMontaCarga />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/gestion-tareas/calendario"
          element={
            <RequiredAuth redirectTo="/">
              <Calendar />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/registrar-usuario"
          element={
            <RequiredAuth redirectTo="/">
              <RegistrarUsuario />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/consultar-numero-celular"
          element={
            <RequiredAuth redirectTo="/">
              <ConsultarNumero />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/registrar-numero-celular"
          element={
            <RequiredAuth redirectTo="/">
              <RegistrarNumero />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/gestion-datos/configuracion"
          element={
            <RequiredAuth redirectTo="/">
              <Datos_Configuracion />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/caracterizacion-evaluacion-control-de-riesgo"
          element={
            <RequiredAuth redirectTo="/">
              <CECDR />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path="/vehiculos-seguros/inspeccion-vehiculos"
          element={
            <RequiredAuth redirectTo="/">
              <VehicleInspection />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/vehiculos-seguros/indicador-ESV"
          element={
            <RequiredAuth redirectTo="/">
              <IndicadorESV />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/encuesta/esv"
          element={
            <RequiredAuth redirectTo="/">
              <EncuestaEsv />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/preguntas/esv"
          element={
            <RequiredAuth redirectTo="/">
              <PreguntasEsv />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/administrar-encuestados"
          element={
            <RequiredAuth redirectTo="/">
              <AdministrarEncuestado />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/gestion-mantenimiento-vehiculos"
          element={
            <RequiredAuth redirectTo="/">
              <MantenimientoVehiculos />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/Indicadores"
          element={
            <RequiredAuth redirectTo="/">
              <Indicadores />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/FormularioIndicadores"
          element={
            <RequiredAuth redirectTo="/">
              <FormularioIndicadores />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/gestion-mantenimiento/consultar-kilometraje"
          element={
            <RequiredAuth redirectTo="/">
              <ConsultarKilometraje />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/gestion-mantenimiento/registrar-kilometraje/:datos"
          element={
            <RequiredAuth redirectTo="/">
              <RegistrarKilometraje />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/gestion-mantenimiento/consultar-mantenimiento"
          element={
            <RequiredAuth redirectTo="/">
              <ConsultarMantenimiento />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/gestion-mantenimiento/registrar-mantenimiento/:datos"
          element={
            <RequiredAuth redirectTo="/">
              <RegistrarMantenimiento />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/gestion-mantenimiento/ficha-mantenimiento"
          element={
            <RequiredAuth redirectTo="/">
              <FichaMantenimiento />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/gestion-mantenimiento/indicador-flota"
          element={
            <RequiredAuth redirectTo="/">
              <IndicadorFlota />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/gestion-mantenimiento/consultar-rutinas"
          element={
            <RequiredAuth redirectTo="/">
              <ConsultarRutina />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/gestion-mantenimiento/informeKilometraje"
          element={
            <RequiredAuth redirectTo="/">
              <InformeKilometraje />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path="/gestion-mantenimiento/rutinas/:datos"
          element={
            <RequiredAuth redirectTo="/">
              <RegistrarRutina />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.REGISTER_ACCIDENTS}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterAccidents />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path={ROUTES.REGISTER_INVESTIGATION}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterInvestigation />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path={ROUTES.REGISTER_CLAIMS_AND_LEGAL_COSTS}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterClaimsAndLegalCosts />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path={ROUTES.REGISTER_DISSEMINATION_LESSON}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterDisseminationLesson />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.RISK_MATRIX}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterRiskMatrix />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.IDENTIFIED_RISKS}
          element={
            <RequiredAuth redirectTo="/">
              <IdentifiedRisks />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.WORK_PLAN_AND_TRAINING}
          element={
            <RequiredAuth redirectTo="/">
              <WorkPlanAndTraining />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.COMPLIANCE_ANNUAL_PLAN_ACTIVITIES}
          element={
            <RequiredAuth redirectTo="/">
              <ComplianceAnnualPlanActivities />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.GOALS_AND_COMPLIANCE}
          element={
            <RequiredAuth redirectTo="/">
              <GoalsAndCompliance />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.VARIOUS_DOCUMENT_ADMIN}
          element={
            <RequiredAuth redirectTo="/">
              <VariousDocumentAdmin />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.LIST_MAINTENANCE}
          element={
            <RequiredAuth redirectTo="/">
              <ListMaintenance />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path={ROUTES.REGISTER_MAINTENANCE}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterMaintenance />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.LIST_SPEED_MANAGMENT}
          element={
            <RequiredAuth redirectTo="/">
              <ListSpeedManagment />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.REGISTER_SPEED_MANAGMENT}
          element={
            <RequiredAuth redirectTo="/">
              <SpeedManagment />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path={ROUTES.PREOPERATIVE}
          element={
            <RequiredAuth redirectTo="/">
              <Preoperative />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path={ROUTES.SUB_MAINTENANCE}
          element={
            <RequiredAuth redirectTo="/">
              <SubMaintenance />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path={ROUTES.MONTHLY_REPORT}
          element={
            <RequiredAuth redirectTo="/">
              <MonthlyReport />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path={ROUTES.NUMBER_OF_TRIPS}
          element={
            <RequiredAuth redirectTo="/">
              <NumberOfTrips />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path={ROUTES.LIST_INFRACTIONS}
          element={
            <RequiredAuth redirectTo="/">
              <ListInfractions />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.REGISTER_INFRACTIONS}
          element={
            <RequiredAuth redirectTo="/">
              <Infractions />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.LIST_CALL_TO_ATTENTION}
          element={
            <RequiredAuth redirectTo="/">
              <ListCallToAttention />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.REGISTER_CALL_TO_ATTENTION}
          element={
            <RequiredAuth redirectTo="/">
              <CallToAttention />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.EXCEL_VEHICLE_INSPECTION}
          element={
            <RequiredAuth redirectTo="/">
              <ExcelVehicleInspection />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path={ROUTES.COPY_FORMATS_USED}
          element={
            <RequiredAuth redirectTo="/">
              <CopyFormatsUsed />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path={ROUTES.RELATION_PREVENTIVE_MAINTENANCE}
          element={
            <RequiredAuth redirectTo="/">
              <RelationPreventiveMaintenance />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path={ROUTES.COUNT_FAULTS}
          element={
            <RequiredAuth redirectTo="/">
              <CountFaults />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.LIST_ACCIDENTS}
          element={
            <RequiredAuth redirectTo="/">
              <ListAccidents />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.LIST_INVESTIGATION}
          element={
            <RequiredAuth redirectTo="/">
              <ListInvestigations />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.LIST_DISSEMINATION_LESSON}
          element={
            <RequiredAuth redirectTo="/">
              <ListDisseminationLesson />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.INDICATORS}
          element={
            <RequiredAuth redirectTo="/">
              <Indicators />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.LIST_LEGAL_PROCESS_DOCUMENTS}
          element={
            <RequiredAuth redirectTo="/">
              <ListLegalProcessDocuments />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path={ROUTES.REGISTER_LEGAL_PROCESS_DOCUMENTS}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterLegalProcessDocuments />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.LIST_LEGAL_PROVISION_DOCUMENTS}
          element={
            <RequiredAuth redirectTo="/">
              <ListLegalProvisionDocuments />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.REGISTER_LEGAL_PROVISION_DOCUMENTS}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterLegalProvisionDocuments />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.LIST_AUDIT_LOGS}
          element={
            <RequiredAuth redirectTo="/">
              <ListAuditLogs />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.LIST_FUNCTIONALITY_INDICATORS}
          element={
            <RequiredAuth redirectTo="/">
              <ListFunctionalityIndicators />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.REGISTER_FUNCTIONALITY_INDICATORS}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterFunctionalityIndicators />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.REGISTER_DAILY_FUNCTIONALITY_INDICATORS}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterDailyIndicators />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.REGISTER_MONTHLY_FUNCTIONALITY_INDICATORS}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterMonthlyIndicators />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.LIST_FUNCTIONALITY_MONTHLY_REPORT_PDF}
          element={
            <RequiredAuth redirectTo="/">
              <ListMonthlyReportPdf />
            </RequiredAuth>
          }
        />
        <Route
          exact
          path={ROUTES.REGISTER_FUNCTIONALITY_MONTHLY_REPORT_PDF}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterMonthlyReportPdf />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.LIST_FUNCTIONALITY_SPEED_LIMIT_CERTIFICATE}
          element={
            <RequiredAuth redirectTo="/">
              <ListSpeedLimitCertificate />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.REGISTER_FUNCTIONALITY_SPEED_LIMIT_CERTIFICATE}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterSpeedLimitCertificate />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.LIST_FUNCTIONALITY_STAFF_TIME_CONTROL}
          element={
            <RequiredAuth redirectTo="/">
              <ListStaffTimeControl />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.REGISTER_FUNCTIONALITY_STAFF_TIME_CONTROL}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterStaffTimeControl />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.LIST_FUNCTIONALITY_WORK_ROUTES_LIST}
          element={
            <RequiredAuth redirectTo="/">
              <ListWorkRoutesList />
            </RequiredAuth>
          }
        />

        <Route
          exact
          path={ROUTES.REGISTER_FUNCTIONALITY_WORK_ROUTES_LIST}
          element={
            <RequiredAuth redirectTo="/">
              <RegisterWorkRoutesLst />
            </RequiredAuth>
          }
        />
      </Route>
    </Routes>
  );
}

function Layout() {
  return (
    <div style={{ height: "100vh", overflow: "hidden" }}>
      <div className="h-100 d-flex flex-column oerflow-hidden">
        <Navegador />
        <div className="overflow-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
export { Rutas };
